import { render, staticRenderFns } from "./GalleryFilterDefaultLayout.vue?vue&type=template&id=37e22a41&scoped=true"
import script from "./GalleryFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./GalleryFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e22a41",
  null
  
)

export default component.exports